import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import nl from 'vuetify/es5/locale/nl'

Vue.use(Vuetify)

export default new Vuetify({
  lang: {
    locales: { nl },
    current: 'nl'
  },
  icons: {
    iconfont: 'fa'
  },
  theme: {
    themes: {
      light: {
        primary: '#002F4E',
        secondary: '#00FFEC',
      }
    }
  }
})
